const QuestionState = {
  questions: [],
};

export default QuestionState;
